import { useMemo } from 'react';
import { useEntrance } from '../context/entrance-context';
import { ENTRANCE_CATEGORY_COLORS, ENTRANCE_CATEGORY_LABELS } from '../data/entrance-types';
import type { EntranceCategory } from '../data/entrance-types';

export function EntranceStats() {
  const { state } = useEntrance();

  const stats = useMemo(() => {
    const byCategory: Record<string, { total: number; tracked: number }> = {};
    let totalTracked = 0;
    let totalAll = 0;

    for (const conn of Object.values(state.connections)) {
      if (!state.visibleCategories.includes(conn.category)) continue;
      if (!state.visibleZones.includes(conn.zone)) continue;

      if (!byCategory[conn.category]) {
        byCategory[conn.category] = { total: 0, tracked: 0 };
      }
      byCategory[conn.category].total++;
      totalAll++;
      if (conn.isTracked) {
        byCategory[conn.category].tracked++;
        totalTracked++;
      }
    }

    return { byCategory, totalTracked, totalAll };
  }, [state.connections, state.visibleCategories, state.visibleZones]);

  return (
    <div className="flex flex-wrap items-center gap-3 text-[11px]">
      <span className="text-gray-400">
        <span className="text-white font-bold">{stats.totalTracked}</span>
        /{stats.totalAll} tracked
      </span>
      {Object.entries(stats.byCategory).map(([cat, s]) => (
        <span key={cat} className="flex items-center gap-1">
          <span
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: ENTRANCE_CATEGORY_COLORS[cat as EntranceCategory] }}
          />
          <span className="text-gray-500">
            {ENTRANCE_CATEGORY_LABELS[cat as EntranceCategory]}:
          </span>
          <span className="text-gray-300">
            {s.tracked}/{s.total}
          </span>
        </span>
      ))}
    </div>
  );
}
